import { dynamicMiddlewaresInstance } from "@/core/store"
import type { Middleware } from "@reduxjs/toolkit"
import { clearPublicationDrafts } from "../hooks/publicationSessionDraft"
import { clearPublicationPreviews } from "../hooks/usePublicationPreview"
import { postBotSessionIdentity } from "../utils/sessionIdentity"
import { businessApi } from "./publications/api"
import { mediaAccessOwner } from "./mediaAccessSession"

// Installed once by App, not by a page effect. Token refresh / route changes
// preserve memory. Redux auth reset (including failed reauth) clears it even if
// no PostBot page is mounted. Reset request IDs also rejects late RTK responses.
const publicationSessionLifecycle: Middleware = (api) => (next) => (action) => {
  const previous = postBotSessionIdentity(api.getState().auth)
  const result = next(action)
  if (previous !== postBotSessionIdentity(api.getState().auth)) {
    clearPublicationDrafts()
    clearPublicationPreviews()
    mediaAccessOwner.clear()
    api.dispatch(businessApi.util.resetApiState())
  }
  return result
}
dynamicMiddlewaresInstance.addMiddleware(publicationSessionLifecycle)
